<script lang="ts" setup>
import type { ItemReorderCustomEvent } from '@ionic/core';

const { t } = useEkI18n();

const toggleRefs = ref<{ [element in HomepageElement]: ComponentPublicInstance | null }>({
  [HomepageElement.HourRegistrationOverview]: null,
  [HomepageElement.NextWorksheet]: null,
  [HomepageElement.NextCalendarEvent]: null,
  [HomepageElement.WorksheetActiveTimer]: null,
  [HomepageElement.OverdueWorksheet]: null
});

function saveToggleRef(element: HomepageElement, refElement: Element | ComponentPublicInstance | null) {
  if (refElement === null || refElement instanceof Element === true) {
    return;
  }

  toggleRefs.value[element] = refElement;
}

const settingsStore = useSettingsStore();

async function updateHomepageLayout(key: HomepageElement, value: boolean) {
  const elements = settingsStore.deepCopySetting('homepageLayout');
  elements[key] = value;

  await settingsStore.set('homepageLayout', elements);

  if (key === HomepageElement.HourRegistrationOverview && !value) {
    await settingsStore.set('showNonStandardUnitHourRegistrationsDashboard', false);
  }
}

async function handleReorder(event: ItemReorderCustomEvent) {
  const elements = settingsStore.deepCopySetting('homepageLayoutOrder');
  event.detail.complete(elements);

  await settingsStore.set('homepageLayoutOrder', elements);
}

</script>

<template>
  <IonItem lines="none">
    <IonLabel>
      {{ t('settings.homepage.layout') }}
      <p>{{ t('settings.homepage.layoutDescription') }}</p>
    </IonLabel>
  </IonItem>
  <IonList>
    <IonReorderGroup
      :disabled="false"
      @ion-item-reorder="handleReorder"
    >
      <IonItem
        v-for="element in settingsStore.settings.homepageLayoutOrder"
        :key="element"
        color="card-background"
        lines="full"
      >
        <IonReorder slot="end" />

        <IonLabel>
          <IonToggle
            :ref="(el)=>saveToggleRef(element, el)"
            :checked="settingsStore.settings.homepageLayout[element]"
            @ion-change="updateHomepageLayout(element, $event.detail.checked)"
          >
            <IonLabel class="ion-text-wrap">
              {{ t(`settings.homepage.element.${element}`) }}
            </IonLabel>
          </IonToggle>
          <p
            class="ion-no-margin"
            @click="toggleRefs[element]?.$el.click($event)"
          >
            {{ t(`settings.homepage.element.${element}Description`) }}
          </p>
        </IonLabel>
      </IonItem>
    </IonReorderGroup>
  </IonList>
</template>

<style scoped>

</style>
